import { render, staticRenderFns } from "./lt-images-galley.vue?vue&type=template&id=0fe49153&scoped=true&"
import script from "./lt-images-galley.vue?vue&type=script&lang=js&"
export * from "./lt-images-galley.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe49153",
  null
  
)

export default component.exports